import { href, redirect } from 'react-router';
import type { Route } from './+types/_index';

export const clientMiddleware: Array<Route.MiddlewareFunction> = [
  ({ params }) => {
    return redirect(href('/projects/:projectId/weekly-planner/plans/lists/:tabId', { ...params, tabId: 'my-plans' }));
  },
];
